export enum VendorPaymentType {
    HARDPAYOUT = "Transfer to wallet",
    SOFTPAYOUT = "Record Payment (Payment Done Already)",
}
